import { render, staticRenderFns } from "./ListItem.vue?vue&type=template&id=b28fe144&scoped=true"
import script from "./ListItem.vue?vue&type=script&lang=ts"
export * from "./ListItem.vue?vue&type=script&lang=ts"
import style0 from "./ListItem.vue?vue&type=style&index=0&id=b28fe144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28fe144",
  null
  
)

export default component.exports